// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"656":"d8f50f43","765":"f77b483a"}[chunkId] + ".chunk.js";
};